export default __webpack_public_path__ + "static/media/web3js.5ccc2ced.jpg";